
































import type { PropType } from '@vue/composition-api';
import {
  nextTick,
  toRef,
  onMounted,
  defineComponent,
  ref,
  onBeforeUnmount,
  computed,
} from '@vue/composition-api';
import { Breakpoint } from '@getaccept/lib-shared/src/enums/breakpoint';
import { ButtonType, ParagraphSize } from '@getaccept/lib-ui';
import DsrTemplatePickerConstants from '@getaccept/lib-shared/src/dsr-template-picker/constants/dsr-template-picker.constants';
import { EnumDocumentType } from '@getaccept/lib-shared/src/enums/DocumentType';
import { PathName } from '@getaccept/lib-shared/src/enums/PathNames';
import { DsrService } from '../api/dsr/services/dsr.service';
import router from '../router/router';

export default defineComponent({
  props: {
    contentRef: {
      type: HTMLDivElement as PropType<HTMLDivElement>,
      default: null,
    },
  },
  setup(props, { emit }) {
    const bannerWidth = ref(0);
    const windowSize = ref(window.innerWidth);
    const contentDiv = toRef(props, 'contentRef');
    const loading = ref(false);

    const handleReject = () => {
      localStorage.setItem(DsrTemplatePickerConstants.globalTemplateBannerLocalStorageKey, 'false');
      emit('reject');
    };

    const handleCopyTemplate = async () => {
      loading.value = true;
      try {
        const { id, title: name } = await DsrService.copySampleTemplate(
          DsrTemplatePickerConstants.globalTemplateId
        );
        const dsrId = await DsrService.useTemplate({
          id,
          name,
        });
        if (contentDiv.value) {
          localStorage.setItem(
            DsrTemplatePickerConstants.globalTemplateBannerLocalStorageKey,
            'false'
          );
        }
        if (!contentDiv.value) {
          router.push({
            name: PathName.DsrEdit,
            params: {
              id: dsrId,
            },
          });
          return;
        }
        emit('dsr-created', { id: dsrId, type: EnumDocumentType.DSR });
      } catch (e) {
        console.error(e);
      } finally {
        loading.value = false;
      }
    };

    const templateBannerStyle = computed(() => {
      const marginsWidth = windowSize.value < Breakpoint.XSmall ? 32 : 48;
      const width =
        windowSize.value < Breakpoint.Small
          ? `${bannerWidth.value + marginsWidth}px`
          : `${bannerWidth.value + 48}px`;

      const dsrTemplatePickerBackgroundSVG =
        'PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMzcgMjIwIj48cGF0aCBkPSJNMCAzMTRjMC0xMTcuNjM3IDk1LjM2My0yMTMgMjEzLTIxM2gzMDB2MjEzSDBaIiBmaWxsPSJ1cmwoI2EpIi8+PHBhdGggZD0iTTEzNyAxOTFjMC0xMTUuNDI3IDkzLjU3Mi0yMDkgMjA5LTIwOWgxNDN2MjA5SDEzN1oiIGZpbGw9InVybCgjYikiLz48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9ImEiIHgxPSIyNTYuNSIgeTE9IjEwMSIgeDI9IjI1Ni41IiB5Mj0iMzE0IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHN0b3Agc3RvcC1jb2xvcj0iIzlDRDBGRiIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzlDRDBGRiIgc3RvcC1vcGFjaXR5PSIwIi8+PC9saW5lYXJHcmFkaWVudD48bGluZWFyR3JhZGllbnQgaWQ9ImIiIHgxPSIzMTMiIHkxPSItMTgiIHgyPSIzMTMiIHkyPSIxOTEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBzdG9wLWNvbG9yPSIjMjU5NkZGIi8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMjU5NkZGIiBzdG9wLW9wYWNpdHk9IjAiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48L3N2Zz4=';
      const dsrTemplatePickerBackgroundDesktopSVG =
        'PHN2ZyB3aWR0aD0iNTEzIiBoZWlnaHQ9IjE4OCIgdmlld0JveD0iMCAwIDUxMyAxODgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8zNzZfMjg0MykiPgo8cGF0aCBkPSJNMCAzMTRDMCAxOTYuMzYzIDk1LjM2MzMgMTAxIDIxMyAxMDFMNTEzIDEwMVYzMTRMMCAzMTRWMzE0WiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzM3Nl8yODQzKSIvPgo8cGF0aCBkPSJNMTYxIDE4M0MxNjEgNjcuNTcyNSAyNTQuNTcyIC0yNiAzNzAgLTI2TDUxMyAtMjZWMTgzTDE2MSAxODNWMTgzWiIgZmlsbD0idXJsKCNwYWludDFfbGluZWFyXzM3Nl8yODQzKSIvPgo8L2c+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMzc2XzI4NDMiIHgxPSIyNTYuNSIgeTE9IjEwMSIgeDI9IjI1Ni41IiB5Mj0iMzE0IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiM5Q0QwRkYiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjOUNEMEZGIiBzdG9wLW9wYWNpdHk9IjAiLz4KPC9saW5lYXJHcmFkaWVudD4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDFfbGluZWFyXzM3Nl8yODQzIiB4MT0iMzM3IiB5MT0iLTI2IiB4Mj0iMzM3IiB5Mj0iMTgzIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiMyNTk2RkYiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMjU5NkZGIiBzdG9wLW9wYWNpdHk9IjAiLz4KPC9saW5lYXJHcmFkaWVudD4KPGNsaXBQYXRoIGlkPSJjbGlwMF8zNzZfMjg0MyI+CjxyZWN0IHdpZHRoPSI1MTMiIGhlaWdodD0iMTg4IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPg==';

      const backgroundImage = `url('data:image/svg+xml;base64,${
        windowSize.value < Breakpoint.Small
          ? dsrTemplatePickerBackgroundSVG
          : dsrTemplatePickerBackgroundDesktopSVG
      }')`;

      return {
        backgroundImage,
        ...(contentDiv.value ? { width } : {}),
      };
    });

    const updateWidth = () => {
      bannerWidth.value = contentDiv.value?.offsetWidth ?? 0;
      windowSize.value = window.innerWidth;
    };

    onMounted(async () => {
      await nextTick();
      if (!contentDiv.value) {
        return;
      }
      bannerWidth.value = contentDiv.value?.offsetWidth ?? 0;
      window.addEventListener('resize', updateWidth);
    });

    onBeforeUnmount(() => window.removeEventListener('resize', updateWidth));

    return {
      ButtonType,
      ParagraphSize,
      templateBannerStyle,
      loading,
      contentDiv,
      handleReject,
      handleCopyTemplate,
    };
  },
});
